import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../../../core/navigation.service';
import { LeftPanelService } from '../../../../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './putaway-primary-accordian.component.html',
  styleUrls: ['./putaway-primary-accordian.component.css']
})
export class  PutAwayPrimaryAccordionComponent extends AbstractFormWidgetComponent {


  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
    }


}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/strategies/putaway-strategy/putaway-strategy-home/putaway-strategy-primary-accordion/putaway-primary-accordiancomponent.ts